var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoAgregarBeneficiario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 42.125C69.375 39.875 66.25 39.375 64 41L49 52.125H33.875C32.875 52.125 32 51.125 32 50.125C32 49 33 48.125 33.875 48.125H43.75C45.625 48.125 47.5 46.75 47.875 44.75C48.25 42.25 46.375 40.125 43.875 40.125H23.875C20.625 40.125 17.125 41.25 14.5 43.375L8.75 48.125L1.875 48C0.875 48 0 49 0 50V62C0 63.125 0.875 64 1.875 64H45.125C47.875 64 50.625 63.125 52.75 61.5L69.75 49.125C72.125 47.5 72.625 44.375 71 42.125ZM20 22H28V30C28 31.125 28.875 32 30 32H38C39 32 40 31.125 40 30V22H48C49 22 50 21.125 50 20V12C50 11 49 10 48 10H40V2C40 1 39 0 38 0H30C28.875 0 28 1 28 2V10H20C18.875 10 18 11 18 12V20C18 21.125 18.875 22 20 22Z",
    fill: "#F0F0EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgregarBeneficiario);
export default __webpack_public_path__ + "static/media/icono_agregarBeneficiario.ddeae7197110c591a6bff0ad4e0e8441.svg";
export { ForwardRef as ReactComponent };